import {
    CHANGE_BANK,
    CHANGE_DOCUMENT_NUMBER,
    CHANGE_EMAIL,
    CHANGE_FULLNAME,
    FETCH_BANKS_SUCCESS,
    VALIDATE_DOCUMENT_NUMBER,
    VALIDATE_EMAIL,
    VALIDATE_FULLNAME
} from "../actions"

const initialState = {
    fullName: "",
    documentType: 1,
    documentNumber: "",
    banks: [],
    fullNameError: null,
    documentNumberError: null,
    emailError: "",

    hasErrors: true
}

/**
 * Handles a given action, as long as it's related to the Offline Payment Form. Throws away any other action.
 *
 * @param state: The state to modify due to the action.
 * @param action: The action to used wehn modifying the state.
 * @returns {object} The state being the one but already modified according to the given action.
 */
export function offlinePaymentForm(state = initialState, action) {
    let newState = state

    switch (action.type) {
        case CHANGE_FULLNAME:
            newState = {
                ...state,
                fullName: action.fullName,
            }
            break

        case VALIDATE_FULLNAME:
            newState = {
                ...state,
                fullNameError: action.fullNameError
            }
            newState.hasErrors = hasErrors(newState)
            break

        case VALIDATE_EMAIL:
            newState = {
                ...state,
                emailError: action.emailError
            }
            newState.hasErrors = hasErrors(newState)
            break

        case CHANGE_DOCUMENT_NUMBER:
            newState = {
                ...state,
                documentType: action.documentType,
                documentNumber: action.documentNumber,
            }
            break

        case CHANGE_EMAIL:
            newState = {
                ...state,
                email: action.email,
            }
            break

        case CHANGE_BANK:
            newState = {
                ...state,
                bank: action.bank,
            }
            break

        case VALIDATE_DOCUMENT_NUMBER:
            newState = {
                ...state,
                documentNumberError: action.documentNumberError
            }
            newState.hasErrors = hasErrors(newState)
            break

        case FETCH_BANKS_SUCCESS:
            newState = {
                ...state,
                banks: action.banks.list
            }
            newState.hasErrors = hasErrors(newState)
            break

        default:
            break
    }

    return newState
}

/**
 * Determines if the Offline Payment form has an error.
 *
 * @param fullNameError: The error related to the full name.
 * @param documentNumberError: The error related to the document number.
 * @returns {boolean} True if the Form has errors; false otherwise.
 */
function hasErrors({fullNameError, documentNumberError, emailError}) {
    return fullNameError !== "" || documentNumberError !== "" || emailError !== ""
}
